"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardPhotoFooterMixin = void 0;
var _styledComponents = require("styled-components");
/** @class PropertyCardPhotoFooterMixin */
/** @method */
/**
 * Using `justify-self: flex-end` to allow as much of the photo to be clickable as
 * possible (CDS-1777)
 */
var PropertyCardPhotoFooterMixin = /*#__PURE__*/(0, _styledComponents.css)(["grid-area:photo-bottom;justify-self:flex-end;z-index:1;"]);
exports.PropertyCardPhotoFooterMixin = PropertyCardPhotoFooterMixin;